import { constants, getImageSize } from 'assets/utilities';
import cartModel from 'assets/components/cart/cartModel';

import { getCartItemGroups } from './cartListUtils';

const { stylePrice } = cartModel;

const {
  ADD_ON_TYPE,
  ENABLE_FREQUENCY,
  FREQUENCY_OPTIONS,
} = constants;

const templateFrequencyDesktopUI = (props = {}) => {
  const { frequency = '', group } = props;
  return `<div class="cart-list__frequency cart-list__frequency--desktop">
    <fieldset>
      <legend class="visually-hidden">${constants.cart.frequencyHeading}</legend>
      <ul class="cart-list__frequency__options">
      ${FREQUENCY_OPTIONS.map(option => `<li class="cart-list__frequency__option">
        <input
          ${option.value * 1 === frequency * 1 ? 'checked' : ''}
          class="js-cartListFrequencyOption"
          data-frequency="${frequency}"
          data-lines="${group.map(({ line }) => line).join(',')}"
          id="frequency-${group.map(({ line }) => line).join(',')}-${option.value}"
          name="frequency-${group.map(({ line }) => line).join(',')}"
          type="radio"
          value="${option.value}"
        />
        <label for="frequency-${group.map(({ line }) => line).join(',')}-${option.value}">
          ${option.name}
        </label>
        </li>`).join('')}
      </ul>
    </fieldset>
  </div>`;
};

const templateFrequency = (props = {}) => {
  const { frequency = '', group } = props;
  if (!frequency) {
    return '';
  }

  return `<div class="cart-list__box cart-list__box--frequency">
  <div class="cart-list__heading">
    <svg role="presentation" viewBox="0 0 13 19">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-subscription"></use>
    </svg>
    ${constants.cart.frequencyHeading}
  </div>
  ${ENABLE_FREQUENCY ? `
  <div class="cart-list__frequency cart-list__frequency--mobile">
    <div class="select-wrapper">
      <select
        aria-label="${constants.cart.frequencyLabel}"
        class="select js-cartListFrequency"
        data-lines="${group.map(({ line }) => line).join(',')}"
        id="frequency-${group.map(({ line }) => line).join(',')}"
        name="frequency"
      >
        ${FREQUENCY_OPTIONS.map(option =>
    `<option${option.value === frequency * 1 ? ' selected' : ''} value="${option.value}">${option.name}</option>`)
    .join('')}
      </select>
    </div>
  </div>` : ''}
  ${ENABLE_FREQUENCY ? templateFrequencyDesktopUI(props) : ''}
</div>`;
};

const templateItem = (props = {}) => {
  const isQtyDisabled = props.product_type === constants.cart.trialType;
  const packSize = props?.properties?.trial_pack; // eslint-disable-line camelcase
  let packQuantity;
  if (packSize && props.product_title.indexOf('Trial Kit') === -1) { // eslint-disable-line camelcase
    packQuantity = packSize.split(' ')[0]; //eslint-disable-line
  }

  return `<div class="cart-list__item${!props.frequency ? ' cart-list__item--one-time' : ''}">
  <a href="/products/${props.handle}">
    <img
      alt=""
      src="${getImageSize(props.image, '92x92')}"
      srcset="${getImageSize(props.image, '184x184')}"
    />
    <div class="cart-list__name">
      ${props.product_title}
      <span class="cart-list__price-mobile"> -&nbsp;${props.original_price !== props.price
    ? `<del class="cart-list__price-mobile__old igComparePrice" data-product-id="pack-${packQuantity}">${stylePrice(props.original_price)}</del>
        <span class="cart-list__price-mobile__new ${ props.future_trial ? 'igPrice' : '' }" data-product-id="pack-${packQuantity}">${stylePrice(props.price)}</span>`
    : `<span class="${ props.future_trial ? 'igPrice' : '' }" data-product-id="pack-${packQuantity}">${stylePrice(props.price)}</span>`}</span>
    </div>
  </a>
  <ul class="cart-list__options">
    ${props.variant_options.map(option => `<li>${option}</li>`).join('')}
  </ul>
  <button class="cart-list__remove js-cartListRemove" data-line="${props.line}">
    Remove${props.product_type === ADD_ON_TYPE ? ' <span>from kit</span>' : ''}
  </button>
  <div class="cart-list__qty${isQtyDisabled ? ' cart-list__qty--disabled' : ''}">
    <label for="qty-${props.line}">Qty:</label>
    <select data-line="${props.line}" class="js-cartListQty" id="qty-${props.line}" name="qty">
      ${[...Array(9)].map((qty, index) =>
    `<option${index + 1 === props.quantity * 1 ? ' selected' : ''}${isQtyDisabled ? ' disabled' : ''}>
  ${index + 1}
</option>`).join('')}
    </select>
  </div>
  <div class="cart-list__qty-buttons${isQtyDisabled ? ' cart-list__qty-buttons--disabled' : ''}">
    <span class="cart-list__label-desktop">Quantity</span>
    <button${props.quantity <= 1 || isQtyDisabled ? ' disabled' : ''} id="cart-minus-${props.line}" data-line="${props.line}" class="js-cartListMinus" aria-label="${constants.cart.decreaseQuantity}">-</button>
    ${props.quantity}
    <button${isQtyDisabled ? ' disabled' : ''} data-line="${props.line}" id="cart-plus-${props.line}" class="js-cartListPlus" aria-label="${constants.cart.increaseQunatity}">+</button>
  </div>
  <div class="cart-list__price-desktop">
    <span class="cart-list__label-desktop">Total</span>
    ${props.original_price !== props.price
    ? `<del class="cart-list__price-desktop__old igComparePrice" data-product-id="pack-${packQuantity}">${stylePrice(props.original_price)}</del>
      <span class="cart-list__price-desktop__new ${ props.future_trial ? 'igPrice' : '' }" data-product-id="pack-${packQuantity}">${stylePrice(props.price)}</span>`
    : `<span class="${ props.future_trial ? 'igPrice' : '' }" data-product-id="pack-${packQuantity}">${stylePrice(props.price)}</span>`}
  </div>
</div>`;
};

const template = (props = { items: [], trialItems: [] }) => {
  props.trialItems.forEach((item) => {
    if (item?.product_type && item.product_type.toLowerCase() == 'trial') {
      item.future_trial = true;
    }
  });

  if (!props.items.length) {
    return `<div class="cart-list__box">
  <div class="cart-list__heading">${constants.cart.empty}</div>
</div>`;
  }
  let output = '';

  output = getCartItemGroups(props.items)
    .map(group => `<div class="cart-list__group">
  <div class="cart-list__box">
    <div class="cart-list__heading">
    ${group[0].frequency ? `
      <svg role="presentation" viewBox="0 0 13 19">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-subscription"></use>
      </svg>
      ${constants.cart.subscriptionHeading}
    ` : constants.cart.todayHeading}
    </div>
    <div class="cart-list__items">${group.map(templateItem).join('')}</div>
  </div>
  ${ENABLE_FREQUENCY ? templateFrequency({ frequency: group[0].frequency, group }) : ''}
</div>`).join('');

  if (props.trialItems && props.trialItems.length) {
    output += `
    <h2 class="cart__title">Future Subscriptions</h2>
    <div class="cart-list__group">
    <div class="cart-list__box">
      <div class="cart-list__heading">
        <svg role="presentation" viewBox="0 0 13 19">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-subscription"></use>
        </svg>
        ${constants.cart.subscriptionHeading}
      </div>
      <div class="cart-list__items">${props.trialItems.map(templateItem).join('')}</div>
    </div>
  </div>`;
  }

  return output;
};

export default template;
